//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common,{ specState } from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import shopCart from '@/components/cusShopCart'

export default {
    name: 'shopCategoryList',
    components: {
        shopCart
    },
    props: {
        scontent:{
            type:String,
            default:''
        },
        defaultStart:{
            type: Boolean,
            default: true,
        }
    },

    data() {
        return {
            argeeDialog:{
                cartFlag: false
            },
            totalPage:1,
            size:100,
            page:1,
            goodsList:[],
            goodsLists:[],
            cary_id:0,
            cartReset:{
                count:1,
                current:0
            },

            goodsData: {
                goods_id: '',
            }

        }
    },
    methods:{

        //打开购物车弹框
        cartDetail(item){
            this.goodsData = item;
            this.argeeDialog.cartFlag=true
        },

        querySearchGoods(id) {

            let content = this.$route.query.sContent || '';
            this.cary_id = id || '';

            let opts = {
                url: api.goodsSearch,
                data: {
                    cate_id: this.cary_id,
                    q: content,
                    storeId: common.getCurStoreId(),
                    page: this.page,
                    size: this.size,
                },
                type:'get'
            };

            common.query(opts).then(res => {
                const handleSpec = new specState(res.data.data);
                this.goodsList = handleSpec.resolve();
            },res => {
                this.$vux.toast.text(res.message);
            });

        },

        //跳转详情页
        goDetail(id){
            this.$router.push({name: "goodsDetail",query: {goodsid: id}});
        },

    },
	mounted(){

        this.defaultStart && this.querySearchGoods()

	}
}



// WEBPACK FOOTER //
// ./src/components/shopCategoryList.vue